import { o as t, c as s, a as e } from "./core.0767a1be.js";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "24",
  class: "arrow text-skin-message-arrow"
}, o = /* @__PURE__ */ e("path", {
  d: "M0 2h28v13H14",
  class: "line stroke-current fill-none stroke-2"
}, null, -1), n = /* @__PURE__ */ e("path", {
  d: "M18 9 8 15l10 6",
  class: "head stroke-current fill-current stroke-2"
}, null, -1), a = [
  o,
  n
];
function c(l, h) {
  return t(), s("svg", r, a);
}
const i = { render: c };
export {
  i as default,
  c as render
};
//# sourceMappingURL=message-arrow.305e6afc.js.map
